import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function InstallationScheduleForm({ assignees = [], saving, onSubmit }) {
  const [assigneeId, setAssigneeId] = useState("");
  const [date, setDate] = useState("");
  const valid = Boolean(assigneeId && /^\d{4}-\d{2}-\d{2}$/.test(date));

  const submit = (event) => {
    event.preventDefault();
    if (!valid || saving) return;
    onSubmit({ assignee_id: assigneeId, scheduled_date: date });
  };

  return (
    <Card variant="acta" className="p-5" data-testid="installation-schedule-form">
      <h2 className="font-heading text-lg font-bold text-[var(--do-text)]">Planifier l’installation</h2>
      <p className="mt-2 text-sm text-[var(--do-muted)]">
        Choisissez une date et un intervenant (responsable maintenance ou technicien). L’horaire sera défini ultérieurement.
      </p>
      <form className="mt-4 grid gap-4" onSubmit={submit}>
        <label className="grid gap-1 text-sm font-semibold text-[var(--do-text)]">
          Intervenant
          <Select value={assigneeId} onValueChange={setAssigneeId}>
            <SelectTrigger className="rounded-[10px] border-[var(--do-border)] bg-[var(--do-bg-solid)] text-[var(--do-ink)]">
              <SelectValue placeholder="Sélectionner un intervenant" />
            </SelectTrigger>
            <SelectContent>
              {assignees.map((person) => (
                <SelectItem key={person.id} value={person.id}>
                  {[person.firstName, person.lastName].filter(Boolean).join(" ") || person.email || person.id}
                  {" · "}{person.role === "maintenance_manager" ? "Responsable maintenance" : "Technicien"}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </label>
        <label className="grid gap-1 text-sm font-semibold text-[var(--do-text)]">
          Date d’installation
          <Input required type="date" value={date} onChange={(event) => setDate(event.target.value)}
            className="rounded-[10px] border-[var(--do-border)] bg-[var(--do-bg-solid)] text-[var(--do-ink)]" />
        </label>
        <Button type="submit" variant="actaPrimary" disabled={saving || !valid}>
          {saving ? "Planification en cours…" : "Valider la planification"}
        </Button>
      </form>
    </Card>
  );
}
